import React__default, { useRef, useEffect } from 'react';
import './OnScrollFadeIn.scss.js';

const OnScrollFadeIn = ({ children }) => {
    const [isVisible, setVisible] = React__default.useState(false);
    const domRef = useRef();
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => setVisible(entry.isIntersecting));
        });
        observer.observe(domRef.current);
    }, []);
    return (React__default.createElement("div", { className: `fade-in-section ${isVisible ? "is-visible" : ""}`, ref: domRef }, children));
};

export { OnScrollFadeIn as default };
//# sourceMappingURL=OnScrollFadeIn.js.map
